<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-enroll-button/lecture-enroll-button.component.ts.LectureEnrollButtonComponent.html